import {Injectable} from '@angular/core';
import {interval, Observable, Subject, Subscription} from "rxjs";
import {map} from "rxjs/operators";
import {LIST_SCROLL_INTERVAL} from "../../defines/client.const";

@Injectable({
  providedIn: 'root'
})
export class ScrollDownService {

  private element: HTMLElement | null = null;

  private arScrollDown$ = new Array<Subject<boolean>>();

  public pushScrollDown$(): Observable<boolean> {
    const scrollDown$ = new Subject<boolean>();
    this.arScrollDown$.push(scrollDown$);
    return scrollDown$;
  }

  public popScrollDown$(): void {
    this.arScrollDown$.pop();
  }

  private scrollInterval$: Subscription | null = null;

  constructor() {
  }

  public Start(): void {
    const len = this.arScrollDown$.length;
    const scrollDown$ = len > 0 ? this.arScrollDown$[len - 1] : null;

    if (scrollDown$) {
      scrollDown$.next(true);  // true = 첫번째 스크롤

      this.scrollInterval$ = interval(LIST_SCROLL_INTERVAL).pipe(
        map(() => scrollDown$.next(false)),  // false = 첫번째 이후의 스크롤
      ).subscribe();
    }
    else {
      console.error('ScrollDownService::Start() scrollDown$ is null');
    }
  }

  public Stop(): void {
    if (this.scrollInterval$) {
      this.scrollInterval$.unsubscribe();
      this.scrollInterval$ = null;
    }
  }

}
